<div *ngIf="notice && !notice.document" [innerHTML]="safeNoticeText"></div>
<announcement-view *ngIf="notice && notice.document" [fileDocument]="notice.document"></announcement-view>



// WEBPACK FOOTER //
// /app/src/app/views/announcements/announcements-view-modal/announcements-view-modal.component.html